import UI from "./base/UI";
import { isA11yCheckVersion } from "../functions/a11y.ui";

/**
 * NumberRolling
 */
class NumberRolling extends UI {
    defaults = {};
    constructor(el, options) {
        super('rolling', el);
        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...options};
        this.render();
        const scrollableEl = this.getScrollParent(this.$el[0]);
        this.scrollTarget = scrollableEl;
        if (this.$el.is(':visible')) {
            this.$el.closest('.ui-rolling-wrap').attr('offset-top', this.$el.offset().top + this.scrollTarget.scrollTop)
            if (this.scrollTarget.scrollTop + $(window).height() > this.$el.closest('.ui-rolling-wrap').attr('offset-top') ) {
                this.start();
            } else {
                this.set();
            }
        } else {
            this.set();
        }
        // setTimeout(function(){
        //     $(".ui-rolling[data-rolling-type!='question'] .rolling-box").css('opacity', '1');
        // },100)
        // const config = {
        //     attributes: true,
        // };
        // const callback = (mutaionList,observer) =>{
        //     this.update()
        //     if ($(mutaionList[0].target).closest('.finding-credit-chart').length > 0) {
        //         console.log(1111)
        //     }
        // }
        // const observer = new MutationObserver(callback);
        // observer.observe(this.el, config);
    }

    render() {
        this.detachEvents();
        this.attachEvents();
    }

    attachEvents() {
        const scrollableEl = this.getScrollParent(this.$el[0]);
        this.scrollTarget = scrollableEl;
        let _scrollPercent = this.$el.attr('data-rolling-scroll') == undefined ? 0 : 100 - this.$el.attr('data-rolling-scroll');
        $(this.scrollTarget).on(`scroll${this.eventId}`, (e) => {
            if (this.$el.closest('.ui-rolling-wrap').attr('offset-top') != undefined && this.$el.closest('.ui-rolling-wrap').attr('data-action') != 'true') {
                if ($(e.target).scrollTop() + $(window).height() -  ($(window).height() / (100/_scrollPercent)) > this.$el.closest('.ui-rolling-wrap').attr('offset-top')) {
                    this.update(true);
                }
            }
        });
    }
    /**
     * @summary start 함수 
     * @param {boolean} force defalut false  true 이면 강제로 시작
     * @example
     * $('.ui-rolling').data('ui').start()
     */
    start(force = false){
        let _that = this;
        force = force == 'update' ? true : force;
        this.set(force);
        if (this.defaults.prevNumber == this.defaults.counterNum && force == false) {
            return false;
        }
        this.$el.closest('.ui-rolling-wrap').attr('data-action', true)
        var _height = this.$el.find('.num-wrap').outerHeight();
        if (!this.$el.find('.rolling-num.active').length > 0) {
            this.$el.find('.rolling-num').each((idx,el)=>{
                startAnimation(el, 'count', idx)
                if ($(el).next('.defalut-type').length > 0) {
                    startAnimation($(el).next('.defalut-type')[0], 'defalut', idx)
                }
            })
        }
        
        function startAnimation(el, type, _index) {
            let $rolling =  $(el).closest('.ui-rolling');
            let option = [];
            $(el).addClass('active')
            if (type == 'count') {
                option = [
                    {transform: `translateY(0)`, opacity: 0},
                    {transform: `translateY(calc(-100% + ${_height}px))`, opacity: 1},
                ]
            } else {
                option = [
                    {transform: `translateY(0)`, opacity: 1},
                    {opacity: 0},
                    {opacity: 0},
                    {opacity: 0},
                    {transform: `translateY(-100%)`, opacity: 0},
                ]
            }
            let rollingAni = new Animation(
                new KeyframeEffect(
                    el,
                    option,
                    {
                        duration:$rolling.attr('data-rolling-duration') == undefined ? 1000 : Number($rolling.attr('data-rolling-duration')),
                        easing: $rolling.attr('data-rolling-easing') == undefined ? 'ease' : $rolling.attr('data-rolling-easing'),
                        fill:'forwards',
                        delay: _that.delay($rolling,_index),
                    }
                )
            );
             // 롤링되기전 숫자 안보이게끔 처리, shodow효과 적용 2025.01.22 (CHPFMTASK-1188)
            if ($rolling.attr('data-rolling-shadow') != undefined) {
                $rolling.closest('.ui-rolling-wrap').addClass('shadow');
                $rolling.find('.rolling-box').css('opacity', '0');
                setTimeout(function(){
                    $rolling.find('.rolling-box').css('opacity', '1');
                },100)
            }
            // 롤링되기전 숫자 안보이게끔 처리 2025.01.22 (CHPFMTASK-1188)
            // console.log('000')
            // if($rolling.attr('data-rolling-type') == undefined || !$rolling.attr('data-rolling-type')) {
            //     $rolling.find('.rolling-box').css('opacity', '0');
            //     console.log('111')
            //     setTimeout(function(){
            //         $rolling.find('.rolling-box').css('opacity', '1');
            //         console.log('222')
            //     },100)
            // }
           
            rollingAni.pause();
            rollingAni.play();
            rollingAni.onfinish = () =>{
                if (el.getAttribute('data-num') != undefined) {
                    //$(el).removeClass('active')
                    if ($(rollingAni.effect.target).next('.defalut-type').length > 0) {
                        $(rollingAni.effect.target).next('.defalut-type').remove();
                    }
                    if ($rolling.attr('data-rolling-type') == undefined) {
                        $(rollingAni.effect.target).after(`<div class="num defalut-type">${el.getAttribute('data-num')}</div>`)
                    }
                }
                
            }
        }
        this.defaults.prevNumber = this.defaults.counterNum;
    }
    delay (rolling, _index) {
        let _delay 
        let delayArr = [];
        if (rolling.attr('data-rolling-delay') != undefined && rolling.attr('data-rolling-delay') != 'increase') {
            delayArr = rolling.attr('data-rolling-delay').split(',');
        } 
        _delay = delayArr[_index] == undefined ? 0 : delayArr[_index];
        
        if (rolling.attr('data-rolling-delay') == 'increase' || rolling.attr('data-rolling-type') == 'question') {
            _delay = Number(_index) * 50;
        }
        // console.log('delay', _delay)
        return Number(_delay);
    }
    reset () {

    }
    /**
     * @summary update 함수 
     * @param {boolean} force defalut false  true 이면 강제로 시작
     * @example
     * $('.ui-rolling').data('ui').update()
     */
    update(force = false) {
        console.log('update');
        if (this.scrollTarget.scrollTop + $(window).height() > this.$el.closest('.ui-rolling-wrap').attr('offset-top') ) {
            this.start(force);
        }
         // 신용관리 그래프 리셋 2025.01.23 (CHPFMTASK-1188)
        if (this.$el.closest('.finding-credit-chart').length > 0 && !$('.finding-credit-chart').hasClass('on') && force !='true') { //CHPFMTASK-2264 내신용관리 모듈 미노출 경우 방어로직추가
           console.log('신용관리 그래프 리셋(update)');
           frontUI.svgGraph({id:$('.finding-credit-chart [data-id]').attr('data-id'), reset: true});
        }

        if (this.$el.closest('.finding-credit-chart').length > 0 && (force == true || force =='true')) {  // 메인 - 발견탭 - 신용관리  그래프 active
            // 상세페이지 or 다른탭 이동했다가 돌아왔을때 롤링 안되게끔 처리 25.01.17 (CHPFMTASK-1188)
            // this.$el.closest('.finding-credit-chart').removeClass('on')
            frontUI.svgGraph({id:this.$el.closest('.finding-credit-chart').find('[data-id]').attr('data-id')});
            console.log('신용관리 그래프 실행(update)')
        } 
        
         // 신용관리 그래프 리셋 2025.01.23 (CHPFMTASK-1188)
        
        
        this.attachEvents();
    }
    /**
     * @summary set 함수 
     * @param {boolean} force defalut false  true 애니메이션 없이 세팅
     * @example
     * $('.ui-rolling').data('ui').set()
     */
    set(force = false){
        const currentNum = this.$el.attr('data-rolling-num');
        this.defaults.counterNum = currentNum;

        if (this.defaults.prevNumber == this.defaults.counterNum && force == false) {
            return false;
        }
        if (this.$el.find('.rolling-box').length > 0) {
            this.$el.find('.rolling-box').remove();
            this.$el.find('.hide-txt').remove();
        }
        this.$el.prepend('<div class="hide-txt"><div rolling-num-text></div><div rolling-unit-text></div></div>')
        this.$el.find('[rolling-num-text]').text(this.$el.attr('data-rolling-type') == 'question' ? '?' : currentNum);
        // 불필요한소스 삭제 2025.01.15(CHPFMTASK-1188)
        // this.$el.find('[rolling-unit-text]').text(this.$el.attr('data-rolling-unit'));
        // this.defaults.counterUnit = this.$el.attr('data-rolling-unit');
        const counterSum = this.defaults.counterNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.defaults.counterNumArr = counterSum.split('');
        this.$el.prepend('<div class="rolling-box" aria-hidden="true"></div>');

        if (this.$el.attr('data-rolling-type') == 'question') {
            for (var i = 0; i < this.defaults.counterNumArr.length; i++) {
                if (!isNaN(this.defaults.counterNumArr[i])) {
                    this.defaults.counterNumArr[i] = 8
                }
            }
        }

        for (var i = 0; i < this.defaults.counterNumArr.length; i++) {
            if (isNaN(this.defaults.counterNumArr[i])) {
                this.$el.find('.rolling-box').append(`
                <div class="rolling-comma">,</div>`)
            } else {
                this.$el.find('.rolling-box').append(`
                <div class="num-wrap ">
                    <div class="rolling-num n${i+1}" data-rolling-num="${this.defaults.counterNumArr[i]}">${this.numSetting(Number(i))}</div>
                </div>`)
            }
        }
        var _height = this.$el.find('.num-wrap').outerHeight();
        if (force == true) {
            this.defaults.prevNumber = this.defaults.counterNum;
            this.$el.find('.rolling-num').each(function(idx,el){
                $(el).css({
                    'transtion': 'none',
                    'transform' : `translateY(calc(-100% + ${_height}px))`
                })
            })
        } else {
            this.$el.find('.rolling-num').each(function(idx,el){
                $(el).css({
                    'opacity': 0,
                    'transtion': 'none',
                    'transform' : `translateY(calc(-100% + ${_height}px))`
                })
            })
        }
    }
    numSetting (idx) {
        
        let html = '';
        for (var i = 0; i <= Number(this.defaults.counterNumArr[idx]); i++) {
            if (this.defaults.counterNumArr[idx] == 0) {
                html += `<div class="num">0</div><div class="num">0</div>`
            } else {
                if (this.$el.attr('data-rolling-type') == 'question') {
                    html += `<div class="num">${Math.floor(Math.random() * 10)}</div>`;
                    if (i == 8) {
                        html += `<div class="num type-question">?</div>`;
                    }
                } else {
                    html += `<div class="num">${i}</div>`;
                }
            }
        }
        return html
    }
    detachEvents() {
        this.$el.off(this.eventId);
    }
    getScrollParent (node){
        if (node === null) return null; 
        const overflowY = window.getComputedStyle(node).overflowY;
        if (node.scrollHeight > node.clientHeight && overflowY !== 'visible' && overflowY !== 'hidden') {
            return node;
        } else if (node.tagName.toLowerCase() === 'body' ) {
            return window;
        } else {
            return this.getScrollParent(node.parentNode)
        }
    }
    destroy() {
        this.detachEvents();
    }
}

export default NumberRolling;
